import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 状态
    INTERVIEW_STATUS: computed(() => (
      store.state.label.data.INTERVIEW_MANAGEMENT?.INTERVIEW_STATUS
    )),
    // 是否置顶
    INTERVIEW_IS_TOP: computed(() => (
      store.state.label.data.INTERVIEW_MANAGEMENT?.INTERVIEW_IS_TOP
    )),
    // 平台关系
    INTERVIEW_RANK: computed(() => (
      store.state.label.data.INTERVIEW_MANAGEMENT?.INTERVIEW_RANK
    )),
    // 七牛域名
    QI_NIU_DOMAINS: computed(() => (
      store.state.label.data.QI_NIU_DOMAINS
    )),
    // 搜索表单
    SEARCH_FORM: computed(() => (
      store.state.searchForm.data
    )),
    SET_SEARCH: computed(() => (
      store._mutations.SET_SEARCH
    )),
    // 搜索表单时间
    SEARCH_FORMDAY: computed(() => (
      store.state.searchForm.date
    )),
    SET_SEARCHDAY: computed(() => (
      store._mutations.SET_SEARCHDAY
    ))
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    ...computedData,
    showName
  }
}
